import { useEffect, useState } from 'react';

function usePagination10(totalItems, initialRowsPerPage = 10) {
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(totalItems / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;

    // Corrige a página atual se ultrapassar o total de páginas após filtro
    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(1); // Volta para a primeira página
        }
    }, [totalItems, rowsPerPage, totalPages, currentPage]);

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const goToFirstPage = () => goToPage(1);
    const goToPreviousPage = () => goToPage(currentPage - 1);
    const goToNextPage = () => goToPage(currentPage + 1);
    const goToLastPage = () => goToPage(totalPages);

    return {
        setPagination: {
            totalItems,
            rowsPerPage,
            startIndex,
            currentPage,
            totalPages,
            onRowsPerPageChange: (e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
            },
            onFirstItems: goToFirstPage,
            onPreviousItems: goToPreviousPage,
            onNextItems: goToNextPage,
            onLastItems: goToLastPage,
            onGoToPage: goToPage,
        },
    };
}

export default usePagination10;
